import { Descendant, Text } from "slate";

/**
 * Slate 노드를 HTML 문자열로 직렬화
 */
export function serializeToHTML(nodes: Descendant[]): string {
  return nodes.map(nodeToHTML).join("");
}

function nodeToHTML(node: Descendant): string {
  // 1) 텍스트 노드(Leaf)
  if (Text.isText(node)) {
    let text = node.text;
    let style = "";

    // inline 스타일
    if (node.bold) {
      style += "font-weight: bold; ";
    }
    if (node.underline) {
      style += "text-decoration: underline; ";
    }
    if (node.color) {
      style += `color: ${node.color}; `;
    }
    if (node.fontSize) {
      style += `font-size: ${node.fontSize}; `;
    }

    if (style.trim().length > 0) {
      return `<span style="${style.trim()}">${text ? escapeHtml(text) : "&nbsp;"}</span>`;
    } else {
      return escapeHtml(text);
    }
  }

  // 2) 엘리먼트 노드(블록/링크 등)
  const element = node as any;
  const childrenHTML = element.children.map(nodeToHTML).join("");
  let style = "";

  // **정렬(textAlign)은 블록 요소(`paragraph`, `link`)에서만 적용**
  if (element.textAlign && ["paragraph", "link", "image"].includes(element.type)) {
    style += `text-align: ${element.textAlign}; `;
  }

  switch (element.type) {
    case "paragraph":
      // 블록 레벨 태그: <p style="text-align: ...">...</p>
      return `<p style="${style}">${childrenHTML}</p>`;

    case "link":
      // <a href="..." target="_blank" style="text-align:...">...</a>
      const url = element.url || "#";
      return `<a href="${escapeHtmlAttr(url)}" target="_blank" rel="noopener noreferrer" style="${style}">
        ${childrenHTML}
      </a>`;

    case "image":
      const imgUrl = element.url || "";
      return `<div style="${style}">
        <img 
          src="${escapeHtmlAttr(imgUrl)}" 
          alt="" 
          style="max-width: 100%;" 
        />
      </div>`;

    default:
      // 알 수 없는 타입 -> <div style="...">...</div>
      return `<div style="${style}">${childrenHTML}</div>`;
  }
}

/** 간단한 HTML 이스케이프 */
function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** 속성값(URL 등) 이스케이프 */
function escapeHtmlAttr(str: string): string {
  return escapeHtml(str).replace(/'/g, "&#39;");
}
